import { render } from "./RedesSociais.vue?vue&type=template&id=8036a184&scoped=true&lang=pug"
import script from "./RedesSociais.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesSociais.vue?vue&type=script&setup=true&lang=js"

import "./RedesSociais.vue?vue&type=style&index=0&id=8036a184&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8036a184"]])

export default __exports__